import obterCorDoStatusDaSolicitacao, {
  STATUS,
  obterNomeDoStatus,
  obterStatusPorNome,
} from '../../../../utils/statusDaSolicitacao';

export const SITUACOES = Object.keys(STATUS).reduce((acc, chave) => {
  const nome = obterNomeDoStatus(STATUS[chave]);
  if (nome) acc[chave] = nome;
  return acc;
}, {});

export const PRAZO_EM_DIAS_PARA_ENVIO_DO_DOSSIE = 120;

const IMPEDIMENTO_PRAZO_DO_DOSSIE = 'PRAZO_DO_DOSSIE_EXPIRADO';

const MINIMO_DE_CARACTERES_DA_JUSTIFICATIVA = 10;

const CLASSE_POR_COR = {
  Azul: 'cor-azul',
  Laranja: 'cor-laranja',
  Verde: 'cor-verde',
  Vermelho: 'cor-vermelho',
  Vinho: 'cor-vinho',
};

export function obterTomDaSituacao(situacao) {
  const status = obterStatusPorNome(situacao);

  const cor = obterCorDoStatusDaSolicitacao(status);
  return CLASSE_POR_COR[cor] || 'cor-vermelho';
}

const campoDeObservacao = {
  chave: 'observacao',
  tipo: 'textarea',
  rotulo: 'Observação (registrada no histórico)',
  placeholder: 'Descreva a movimentação para os demais setores...',
};

const campoDeJustificativa = {
  chave: 'justificativa',
  tipo: 'textarea',
  rotulo: 'Justificativa',
  obrigatorio: true,
  minimoDeCaracteres: MINIMO_DE_CARACTERES_DA_JUSTIFICATIVA,
  placeholder: 'Justificativa obrigatória. Ficará no histórico auditável',
};

const indeferir = {
  chave: 'indeferir',
  rotulo: 'Indeferir',
  icone: 'far fa-times',
  destaque: false,
  proximaSituacao: SITUACOES.INDEFERIDO,
  dialogo: {
    titulo: 'Indeferir esta solicitação?',
    mensagem:
      'O indeferimento encerra a solicitação. A justificativa fica registrada no histórico.',
    textoDeConfirmacao: 'Confirmar indeferimento',
    estiloDeConfirmacao: 'contorno-erro',
    campos: [campoDeJustificativa],
  },
};

const protocolarRecebimento = {
  chave: 'protocolarRecebimento',
  rotulo: 'Protocolar recebimento',
  icone: 'far fa-check',
  destaque: true,
  proximaSituacao: SITUACOES.PROTOCOLADO,
  impedimento: {
    chave: IMPEDIMENTO_PRAZO_DO_DOSSIE,
    icone: 'far fa-lock',
    mensagem: `O prazo de ${PRAZO_EM_DIAS_PARA_ENVIO_DO_DOSSIE} dias para envio do dossiê expirou`,
  },
  dialogo: {
    titulo: 'Protocolar o recebimento?',
    mensagem: 'Registra no Habix a documentação recebida por e-mail.',
    responsavel: 'Análise documental',
    textoDeConfirmacao: 'Confirmar protocolo',
    campos: [
      {
        chave: 'dataDocumental',
        tipo: 'data',
        rotulo: 'Data do recebimento',
        obrigatorio: true,
        preencherComHoje: true,
        impedirDataFutura: true,
        ajuda: 'Data em que a documentação foi recebida.',
      },
      campoDeObservacao,
    ],
  },
};

const acoesPorSituacao = {
  [SITUACOES.SOLICITADO]: [
    {
      chave: 'reservar',
      rotulo: 'Reservar',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.RESERVADO,
      dialogo: {
        titulo: 'Reservar esta solicitação?',
        mensagem: `Ao reservar, o subsídio fica confirmado e começa o prazo de ${PRAZO_EM_DIAS_PARA_ENVIO_DO_DOSSIE} dias para o envio do contrato da Caixa e do dossiê.`,
        responsavel: 'Empresa / Corretor',
        textoDeConfirmacao: 'Confirmar reserva',
        campos: [campoDeObservacao],
      },
    },
    indeferir,
  ],
  [SITUACOES.RESERVADO]: [protocolarRecebimento, indeferir],
  [SITUACOES.PRAZO_DOSSIE_VENCIDO]: [protocolarRecebimento, indeferir],
  [SITUACOES.PRAZO_DOSSIE_PRORROGADO]: [protocolarRecebimento, indeferir],
  [SITUACOES.PRAZO_DOSSIE_VENCIDO_PRORROGACAO]: [indeferir],
  [SITUACOES.PROTOCOLADO]: [
    {
      chave: 'iniciarAnalise',
      rotulo: 'Iniciar análise',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.EM_ANALISE,
      dialogo: {
        titulo: 'Iniciar análise',
        mensagem: 'Inicia a análise do dossiê encaminhado pela construtora via e-mail.',
        textoDeConfirmacao: 'Confirmar início da análise',
        campos: [campoDeObservacao],
      },
    },
  ],
  [SITUACOES.EM_ANALISE]: [
    {
      chave: 'marcarComoConforme',
      rotulo: 'Marcar como conforme',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.AGUARDANDO_AUTORIZACAO,
      dialogo: {
        titulo: 'Marcar como conforme?',
        mensagem: 'Exige o número do NUP e encaminha ao gabinete para autorização.',
        responsavel: 'Gabinete',
        textoDeConfirmacao: 'Confirmar conformidade',
        campos: [
          {
            chave: 'numeroDoProcesso',
            tipo: 'texto',
            rotulo: 'Número do NUP',
            obrigatorio: true,
            mascara: '99/999.999/9999',
            padrao: /^\d{2}\/\d{3}\.\d{3}\/\d{4}$/,
            mensagemDoPadrao: 'Informe o NUP no formato XX/XXX.XXX/XXXX',
            placeholder: 'XX/XXX.XXX/XXXX',
          },
          campoDeObservacao,
        ],
      },
    },
    {
      chave: 'marcarComoInconforme',
      rotulo: 'Marcar como inconforme',
      icone: 'far fa-clock',
      destaque: false,
      proximaSituacao: SITUACOES.INCONFORME,
      dialogo: {
        titulo: 'Registrar pendência na documentação?',
        mensagem: 'Registra as pendências e devolve à construtora para correção.',
        responsavel: 'Empresa / Corretor',
        textoDeConfirmacao: 'Registrar pendência',
        estiloDeConfirmacao: 'contorno-primaria',
        campos: [campoDeJustificativa],
      },
    },
  ],
  [SITUACOES.INCONFORME]: [
    {
      chave: 'retomarAnalise',
      rotulo: 'Retomar análise',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.EM_ANALISE,
      dialogo: {
        titulo: 'Retomar a análise?',
        mensagem: 'A documentação corrigida foi recebida e a análise recomeça.',
        responsavel: 'Análise documental',
        textoDeConfirmacao: 'Confirmar retomada',
        campos: [campoDeObservacao],
      },
    },
    indeferir,
  ],
  [SITUACOES.AGUARDANDO_AUTORIZACAO]: [
    {
      chave: 'encaminharParaEmpenho',
      rotulo: 'Encaminhar para empenho',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.EMPENHANDO,
      dialogo: {
        titulo: 'Encaminhar para empenho?',
        mensagem: 'A presidência autorizou. O processo segue para a Diretoria de Administração.',
        responsavel: 'Setor administrativo',
        textoDeConfirmacao: 'Confirmar encaminhamento',
        campos: [campoDeObservacao],
      },
    },
  ],
  [SITUACOES.EMPENHANDO]: [
    {
      chave: 'registrarEmpenho',
      rotulo: 'Registrar empenho',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.EMPENHADO,
      dialogo: {
        titulo: 'Registrar o empenho?',
        mensagem: 'O empenho foi emitido no SPF e o processo retorna para a análise documental.',
        responsavel: 'Análise documental',
        textoDeConfirmacao: 'Confirmar empenho',
        campos: [campoDeObservacao],
      },
    },
  ],
  [SITUACOES.EMPENHADO]: [
    {
      chave: 'gerarMinutaDoContrato',
      rotulo: 'Gerar minuta do contrato',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.CONTRATO_GERADO,
      dialogo: {
        titulo: 'Gerar a minuta do contrato?',
        mensagem: 'A minuta do contrato é gerada com o número do empenho.',
        textoDeConfirmacao: 'Confirmar geração da minuta',
        campos: [campoDeObservacao],
      },
    },
  ],
  [SITUACOES.CONTRATO_GERADO]: [
    {
      chave: 'encaminharAoGabinete',
      rotulo: 'Encaminhar ao gabinete',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.EM_ASSINATURA_DO_GABINETE,
      dialogo: {
        titulo: 'Encaminhar ao gabinete?',
        mensagem: 'Para solicitações da capital, o contrato segue direto ao gabinete.',
        responsavel: 'Gabinete',
        textoDeConfirmacao: 'Confirmar encaminhamento',
        campos: [campoDeObservacao],
      },
    },
    {
      chave: 'encaminharAConstrutora',
      rotulo: 'Encaminhar à construtora',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.EM_ASSINATURA_DA_CONSTRUTORA,
      dialogo: {
        titulo: 'Encaminhar à construtora?',
        mensagem: 'Para solicitações do interior, a construtora coleta as assinaturas.',
        responsavel: 'Empresa / Construtora',
        textoDeConfirmacao: 'Confirmar encaminhamento',
        campos: [campoDeObservacao],
      },
    },
  ],
  [SITUACOES.EM_ASSINATURA_DA_CONSTRUTORA]: [
    {
      chave: 'registrarRetornoDaConstrutora',
      rotulo: 'Registrar retorno e encaminhar ao gabinete',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.EM_ASSINATURA_DO_GABINETE,
      dialogo: {
        titulo: 'Registrar retorno e encaminhar?',
        mensagem: 'A construtora devolveu a documentação assinada e o contrato segue ao gabinete.',
        responsavel: 'Gabinete',
        textoDeConfirmacao: 'Confirmar encaminhamento',
        campos: [campoDeObservacao],
      },
    },
  ],
  [SITUACOES.EM_ASSINATURA_DO_GABINETE]: [
    {
      chave: 'registrarAssinatura',
      rotulo: 'Registrar assinatura e encaminhar para pagamento',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.AGUARDANDO_PAGAMENTO,
      dialogo: {
        titulo: 'Registrar retorno e encaminhar?',
        mensagem: 'A presidência assinou e o processo segue para o setor administrativo.',
        responsavel: 'Setor administrativo',
        textoDeConfirmacao: 'Confirmar encaminhamento',
        campos: [campoDeObservacao],
      },
    },
  ],
  [SITUACOES.AGUARDANDO_PAGAMENTO]: [
    {
      chave: 'registrarPagamento',
      rotulo: 'Registrar pagamento e liquidar',
      icone: 'far fa-check',
      destaque: true,
      proximaSituacao: SITUACOES.SUBSIDIO_LIQUIDADO,
      dialogo: {
        titulo: 'Registrar pagamento e liquidar?',
        mensagem:
          'Informe a primeira ordem bancária (obrigatória) e, se houver, a ordem bancária complementar.',
        textoDeConfirmacao: 'Confirmar pagamento',
        campos: [
          {
            chave: 'ordemBancaria',
            tipo: 'texto',
            rotulo: 'Ordem bancária',
            obrigatorio: true,
            placeholder: 'Ex.: 2026OB0123',
            ajuda: 'Formato: ano + OB + número',
            padrao: /^\d{4}OB\d+$/i,
            mensagemDoPadrao: 'Informe no formato AAAAOB0000 (ex.: 2026OB0123)',
            maiusculo: true,
            meiaLargura: true,
          },
          {
            chave: 'dataDoPagamento',
            tipo: 'data',
            rotulo: 'Data do pagamento',
            obrigatorio: true,
            preencherComHoje: true,
            impedirDataFutura: true,
            meiaLargura: true,
          },
          {
            chave: 'ordemBancariaComplementar',
            tipo: 'texto',
            rotulo: 'Ordem complementar (opcional)',
            placeholder: 'Ex.: 2026OB0123',
            padrao: /^\d{4}OB\d+$/i,
            mensagemDoPadrao: 'Informe no formato AAAAOB0000 (ex.: 2026OB0123)',
            maiusculo: true,
            ocultoPorPadrao: true,
            textoParaExibir: 'Adicionar OB complementar',
          },
          campoDeObservacao,
        ],
      },
    },
  ],
};

const CHAVE_ENCAMINHAR_AO_GABINETE = 'encaminharAoGabinete';
const CHAVE_ENCAMINHAR_A_CONSTRUTORA = 'encaminharAConstrutora';

export function obterAcoesDaSituacao(situacao, impedimentos = {}, ehCapital = false) {
  const acoes = acoesPorSituacao[situacao] || [];

  return acoes
    .filter((acao) => {
      if (acao.chave === CHAVE_ENCAMINHAR_AO_GABINETE) return ehCapital;
      if (acao.chave === CHAVE_ENCAMINHAR_A_CONSTRUTORA) return !ehCapital;
      return true;
    })
    .map((acao) => {
      const impedida = !!acao.impedimento && !!impedimentos[acao.impedimento.chave];
      return Object.assign({}, acao, { impedida });
    });
}

export { IMPEDIMENTO_PRAZO_DO_DOSSIE };



// WEBPACK FOOTER //
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/utils/fluxoDoBonusMoradia.js